import { useState } from 'react';

const faqs = [
  {
    question: 'What does PTA education usually cover?',
    answer:
      'PTA programs commonly include anatomy, physiology, kinesiology, therapeutic exercise, physical agents, mobility, transfers, documentation, professional communication, ethics, safety, and supervised clinical education. Review each school’s current curriculum for the exact course sequence.',
  },
  {
    question: 'Do Florida PTA programs include clinical rotations?',
    answer:
      'CAPTE-accredited PTA education generally includes supervised clinical education in addition to classroom and laboratory instruction. Ask each program where rotations occur, how placements are assigned, whether travel is required, and how many clinical hours are included.',
  },
  {
    question: 'What is required to become a PTA in Florida?',
    answer:
      'Students should complete an approved physical therapist assistant education pathway, meet applicable Florida requirements, and pass the required licensure examination before practicing. Requirements can change, so confirm current information with the Florida Board of Physical Therapy and the program you are considering.',
  },
  {
    question: 'How long does it take to complete a PTA program in Orlando?',
    answer:
      'The timeline varies by school, prerequisites, cohort structure, and enrollment status. Orlando-area options range from accelerated private programs to structured public college sequences. Ask for the complete course map rather than relying only on a marketing timeline.',
  },
  {
    question: 'What should I ask an Orlando PTA school before applying?',
    answer:
      'Ask about CAPTE accreditation status, prerequisites, application deadlines, observation hours, minimum grades, tuition, books, supplies, transportation, clinical placements, graduation and licensure outcomes, class schedules, background checks, immunizations, and available academic support.',
  },
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="directory section" id="faq">
      <div className="section-heading">
        <p className="eyebrow">Plan with confidence</p>
        <h2>Orlando PTA Program FAQs</h2>
        <p>
          Use these answers as a starting point while comparing PTA education
          and physical therapy aide options in Orlando and Central Florida.
          Each institution should provide the most current information about
          admissions, accreditation, clinical education, costs, and licensure
          preparation.
        </p>
      </div>
      <div className="accordion-stack">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;

          return (
            <article
              className={`program-card ${isOpen ? 'open' : ''}`}
              key={faq.question}
            >
              <button
                className="program-trigger"
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
                aria-expanded={isOpen}
              >
                <strong>{faq.question}</strong>
                <span aria-hidden="true">{isOpen ? '−' : '+'}</span>
              </button>
              {isOpen && (
                <div className="program-inner">
                  <p>{faq.answer}</p>
                </div>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default FAQ;